module.exports = __webpack_public_path__ + "static/media/zxs_jc.09ed7ecd.png";